import { Card } from "@repo/components/src/ui/card";
import { Heading } from "@repo/components/src/ui/heading";
import { HStack } from "@repo/components/src/ui/hstack";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import React from "react";

type Props = {
  title: string;
  description?: string;
  right?: React.ReactNode;
  children: React.ReactNode;
};

const Section = React.memo(({ title, description, right, children }: Props) => {
  return (
    <Card variant="outline" className="rounded-2xl" size="lg">
      <HStack className="items-start justify-between mb-4" space="md">
        <VStack space="xs" className="flex-1">
          <Heading size="md" className="text-typography-900">
            {title}
          </Heading>
          {description ? (
            <Text size="sm" className="text-typography-500">
              {description}
            </Text>
          ) : null}
        </VStack>
        {right ? (
          <HStack className="items-center" space="sm">
            {right}
          </HStack>
        ) : null}
      </HStack>
      {children}
    </Card>
  );
});

Section.displayName = "ReportSection";

export default Section;
